import type { IconData } from '@stacksjs/iconify-core'

export const voiceActivation1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3 3c9.521 0 17.253 7.72 17.367 17.286l3.69 5.24c.549.778.452 1.824-.36 2.322c-.815.501-2.027 1.088-3.674 1.493l-.554 6.706a3 3 0 0 1-3.365 2.729l-2.683-.338v3.238c0 1.289-.83 2.416-2.096 2.65C9.606 44.647 6.83 45 3 45m37-27c6.667 6.627 6.667 17.373 0 24m-4.75-20c4 4.418 4 11.582 0 16M29.5 25.5c2.667 2.485 2.667 6.515 0 9M12 18v1\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default voiceActivation1
